import {
  SubscriptionCard,
  SubscriptionCardKind,
} from './get-subscription-cards';

export const getManageableSubscriptionCard = (
  cards: SubscriptionCard[],
): SubscriptionCard | null =>
  cards.find(
    (card) =>
      card.kind === SubscriptionCardKind.Subscription &&
      !!(card.stripeCustomerId || card.managementUrl),
  ) ?? null;
